import React, { useEffect, useState } from "react";
import { useLang } from "../lib/LangContext";
import { Menu, X } from "lucide-react";
import AdtreeLogo from "./AdtreeLogo";

const Navbar = () => {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#about", label: t.nav.about },
    { href: "#services", label: t.nav.services },
    { href: "#benefits", label: t.nav.creators },
    { href: "#testimonials", label: t.nav.testimonial },
    { href: "#register", label: t.nav.join },
  ];

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 flex items-center justify-between h-14 md:h-16">
        <a href="#top" data-testid="logo-link" className="flex items-center group">
          <AdtreeLogo size="md" testId="navbar-logo" />
        </a>

        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-[12px] uppercase tracking-[0.18em] text-white/70 hover:text-brand-yellow transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <div data-testid="lang-toggle" className="hidden sm:flex items-center text-xs font-semibold tracking-widest uppercase border border-white/10">
            <button
              data-testid="lang-id-btn"
              onClick={() => setLang("id")}
              className={`px-2.5 py-1 transition-colors ${
                lang === "id" ? "bg-brand-yellow text-black" : "text-white/70 hover:text-white"
              }`}
            >
              ID
            </button>
            <button
              data-testid="lang-en-btn"
              onClick={() => setLang("en")}
              className={`px-2.5 py-1 transition-colors ${
                lang === "en" ? "bg-brand-yellow text-black" : "text-white/70 hover:text-white"
              }`}
            >
              EN
            </button>
          </div>
          <a
            href="#register"
            data-testid="navbar-cta-join"
            className="hidden md:inline-block bg-brand-yellow text-black font-anton uppercase tracking-widest text-xs px-4 py-2 hover:bg-white transition-colors"
          >
            {t.cta.join}
          </a>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen((s) => !s)}
            className="md:hidden p-2 text-white"
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-widest text-white/80 hover:text-brand-yellow"
              >
                {l.label}
              </a>
            ))}
            <div className="flex items-center gap-2 pt-2">
              <button
                onClick={() => setLang("id")}
                className={`px-3 py-1 text-xs uppercase tracking-widest border ${
                  lang === "id" ? "bg-brand-yellow text-black border-brand-yellow" : "text-white border-white/20"
                }`}
              >
                ID
              </button>
              <button
                onClick={() => setLang("en")}
                className={`px-3 py-1 text-xs uppercase tracking-widest border ${
                  lang === "en" ? "bg-brand-yellow text-black border-brand-yellow" : "text-white border-white/20"
                }`}
              >
                EN
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
